"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- MULTISELECTDROPDOWN : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'MultiSelectDropDown',
  group: _definitionhelpers.groupNames.dropdowns,
  props: {
    name: {
      type: 'string',
      default: 'name'
    },
    title: {
      type: 'string',
      default: 'title'
    },
    icon: {
      type: 'string'
    },
    button: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    disabled: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    searchable: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    editable: {
      type: 'boolean',
      default: true,
      options: [false, true]
    },
    onItemUpdate: {
      type: 'function',
      default: function _default() {
        return console.log('Updated');
      },
      disabled: false,
      help: _definitionhelpers.helpMessages.functions
    },
    onItemDelete: {
      type: 'function',
      default: function _default() {
        return console.log('Deleted');
      },
      disabled: false,
      help: _definitionhelpers.helpMessages.functions
    },
    onSelect: {
      type: 'function',
      default: function _default() {
        return console.log('Selected');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    onNewItemClick: {
      type: 'function',
      default: function _default() {
        return console.log('Trigger New Item');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    buttonAction: {
      type: 'function',
      default: function _default() {
        return console.log('Action Button');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    items: {
      type: 'object',
      default: [{
        value: 'quiz',
        name: 'quiz'
      }, {
        value: 'poll',
        name: 'poll'
      }, {
        value: 'story',
        name: 'story'
      }, {
        value: 'one',
        name: 'one'
      }, {
        value: 'two',
        name: 'two'
      }, {
        value: 'three',
        name: 'three'
      }, {
        value: 'four',
        name: 'four'
      }, {
        value: 'five',
        name: 'five'
      }, {
        value: 'six',
        name: 'six'
      }, {
        value: 'seven',
        name: 'seven'
      }, {
        value: 'eight',
        name: 'eight'
      }, {
        value: 'nine',
        name: 'nine'
      }, {
        value: 'ten',
        name: 'ten'
      }, {
        value: 'custom',
        name: 'this is a really long name to test dropdown'
      }]
    },
    selectedItems: {
      type: 'object',
      default: ['quiz']
    }
  }
};
exports.default = _default2;